import Project from 'src/entities/project';
import PermissionsSwitch from '../PermissionsSwitch/PermissionsSwitch';
import useDownloadsEnabledForReviewers from './useDownloadsEnabledForReviewers';

const DownloadsEnabledForReviewersSwitch = ( { project }: { project: Project } ) => {
	const {
		downloadsEnabledForReviewers,
		onEnabledForReviewersChange
	} = useDownloadsEnabledForReviewers( { project } );

	return (
		<PermissionsSwitch
			label="Download Files"
			description="Includes folders and previous rounds"
			checked={downloadsEnabledForReviewers}
			onChange={onEnabledForReviewersChange}
			styles={{ root: { borderBottom: 'none' } }}
		/>
	);
};

export default DownloadsEnabledForReviewersSwitch;
